// removed by extract-text-webpack-plugin
module.exports = {"img":"Njtmr7T7KpVJ12tmVNk9h","round":"_1-Ivtr2ndUx5BQL0k6MgnJ","clickable":"_1OdIziWQvcAI75lUIjrW8T","overlay":"_15u_fItL_99XzvB26XusLQ"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/Image/Image.scss
// module id = 2124
// module chunks = 1